module.exports = __webpack_public_path__ + "img/Token_p5.17493fb2.png";